import { isMatching, P } from "ts-pattern";

import type { TUser } from "~/types/user";

const userPattern = {
  account_id: P.number,
  account_type_id: P.number,
};

export function isUser(value: unknown): value is TUser {
  return isMatching(userPattern, value);
}
